import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  balance: 0,
  marginUsed: 0,
  available: 0,
  openPnl: 0,
  closedPnl: 0, // ✅ New
  equity: 0,
  totalPnl: 0, // ✅ New (open + closed)
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setAccountBalance(state, action) {
      const { total_balance, margin_used, available_balance } = action.payload;

      state.balance = total_balance;
      state.marginUsed = margin_used;
      state.available = available_balance;
      state.equity = total_balance + state.openPnl;

      // Optionally update totalPnl
      state.totalPnl = state.closedPnl + state.openPnl;
    },
    updateOpenPnl(state, action) {
      state.openPnl = action.payload;
      state.equity = state.balance + state.openPnl;
      state.totalPnl = state.closedPnl + state.openPnl;
    },
    updateClosedPnl(state, action) {
      state.closedPnl += action.payload;
      state.totalPnl = state.closedPnl + state.openPnl;
    },
    addClosedPnl(state, action) {
      state.closedPnl = action.payload;
      state.totalPnl = state.closedPnl + state.openPnl;
    },
  },
});

export const {
  setAccountBalance,
  updateOpenPnl,
  updateClosedPnl,
  addClosedPnl,
} = accountSlice.actions;
export default accountSlice.reducer;
